import { useState } from "react";

// Composer lifecycle for a chat turn, shared by the three send paths so they
// cannot drift apart again.
//
// The box clears the moment a turn is sent -- holding the text through a turn
// invited a second Enter that re-sent the same message. A turn that FAILS hands
// the text (and any attachment) back as a draft, because the transcript bubble
// is not editable: without this the user's only copy of what they typed is gone
// the instant the request errors.
export const useChatComposerDraft = () => {
  const [resetChatBoxInput, setResetChatBoxInput] = useState(false);
  const [restoredChatBoxInput, setRestoredChatBoxInput] = useState(null);

  return {
    resetChatBoxInput,
    setResetChatBoxInput,
    restoredChatBoxInput,
    setRestoredChatBoxInput,
    // Called on send, before the request goes out.
    clearComposer: () => setResetChatBoxInput(true),
    // Called on every terminal failure -- a typed chat fault, a transport
    // error, or a stream that ends without chat_complete.
    restoreComposerDraft: (message, file = null) => {
      setRestoredChatBoxInput({ message, file });
    },
  };
};
